<template>
<div>
  <v-row align="center" justify="center">
    <v-col>
      <v-card class="elevation-8 pt-12 pb-12 pl-6 pr-6">
        <v-img height="120" contain src="../../assets/Pelican_LogoB.png"></v-img>
        </br></br>
        <center>
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='05'">
            <b>
              <font face="微軟正黑體" size="5" color="#5A5AAD">
                {{ $cookie.get('dsmid_token').substr(0,4) }}-{{ $cookie.get('dsmid_token').substr(4,4) }}-{{ $cookie.get('dsmid_token').substr(8,4) }}-{{ $cookie.get('dsmid_token').substr(12,3) }}
              </font></br>
              <font face="微軟正黑體" size="5" color="#5A5AAD">常溫單</font>
            </b>
          </div>
          <div v-else-if="$cookie.get('dsmid_token').substr(1,2)==='15'">
            <b>
              <font face="微軟正黑體" size="5" color="#5B5B5B">
                {{ $cookie.get('dsmid_token').substr(0,4) }}-{{ $cookie.get('dsmid_token').substr(4,4) }}-{{ $cookie.get('dsmid_token').substr(8,4) }}-{{ $cookie.get('dsmid_token').substr(12,3) }}
              </font></br>
              <font face="微軟正黑體" size="5" color="#5B5B5B">低溫單</font>
            </b>
          </div>
          <div v-else>
            <b>
              <font face="微軟正黑體" size="5" color="#000000">
                {{ $cookie.get('dsmid_token').substr(0,4) }}-{{ $cookie.get('dsmid_token').substr(4,4) }}-{{ $cookie.get('dsmid_token').substr(8,4) }}-{{ $cookie.get('dsmid_token').substr(12,3) }}
              </font> <br />
              <font face="微軟正黑體" size="5" color="#000000"></font>
            </b>
          </div>
        </center><br />
        <div v-if="agree_type===false">
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='05'">
            <v-card color="#5A5AAD" class=" pt-2 pb-2">
              <center>
                <b>
                  <font face="微軟正黑體" size="5" color="#E6E6F2">寄件人資料</font>
                </b>
              </center>
            </v-card>
            <v-card color="#E6E6F2" class=" pt-3 pb-6">
              <b>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">寄件人名稱：</font>
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <v-col>
                    <v-text-field dense outlined maxlength="16" background-color="#fff" style="height:30px; width:300px;" v-model="start_name" :rules="start_name_R"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">寄件人連絡電話</font>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">手機：</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="10" background-color="#fff" height="5" style="height: 30px;  width: 200px;" v-model="start_phone" :rules="start_phone_R" placeholder="例:0912345678"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">市話：</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="16" background-color="#fff" height="5" style="height: 30px;  width: 200px;" v-model="start_telphone" :rules="start_telphone_R" placeholder="例:02-12345678#分機"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">寄件人通訊地址</font>
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <SelectZipcode v-model="start_cityIdx" :options="start_cities" />&emsp;
                  <SelectZipcode v-model="start_areaIdx" :options="start_areas" />&ensp;
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <v-col>
                    <v-text-field outlined dense maxlength="24" background-color="#fff" height="5" style="height: 30px;  width: 360px;" v-model="start_address" :rules="start_address_R"></v-text-field>
                  </v-col>
                </v-row>
              </b>
            </v-card>
          </div>
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='15'">
            <v-card color="#5B5B5B" class=" pt-2 pb-2">
              <center>
                <b>
                  <font face="微軟正黑體" size="5" color="#F0F0F0">寄件人資料</font>
                </b>
              </center>
            </v-card>
            <v-card color="#F0F0F0" class=" pt-3 pb-6">
              <b>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">寄件人名稱：</font>
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <v-col>
                    <v-text-field dense outlined maxlength="16" background-color="#fff" style="height:30px; width:300px;" v-model="start_name" :rules="start_name_R"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">寄件人連絡電話</font>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">手機：</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="10" background-color="#fff" height="5" style="height: 30px;  width: 200px;" v-model="start_phone" :rules="start_phone_R" placeholder="例:0912345678"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">市話：</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="16" background-color="#fff" height="5" style="height: 30px;  width: 200px;" v-model="start_telphone" :rules="start_telphone_R" placeholder="例:02-12345678#分機"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">寄件人通訊地址</font>
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <SelectZipcode v-model="start_cityIdx" :options="start_cities" />&emsp;
                  <SelectZipcode v-model="start_areaIdx" :options="start_areas" />&ensp;
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <v-col>
                    <v-text-field outlined dense maxlength="24" background-color="#fff" height="5" style="height: 30px;  width: 360px;" v-model="start_address" :rules="start_address_R"></v-text-field>
                  </v-col>
                </v-row>
              </b>
            </v-card>
          </div>
          <v-card color="#CCA700" class=" pt-2 pb-2">
            <center>
              <b>
                <font face="微軟正黑體" size="5" color="#FFFFDF">收件人資料</font>
              </b>
            </center>
          </v-card>
          <v-card color="#FFFFDF" class=" pt-3 pb-6">
            <b>
              <v-row class="mb-3" no-gutters>
                &ensp;<font face="微軟正黑體" size="4" color="#CCA700">收件人名稱：</font>
              </v-row>
              <v-row class="mb-3" no-gutters>&ensp;
                <v-col>
                  <v-text-field outlined dense maxlength="16" background-color="#fff" style="height: 30px;  width: 300px;" v-model="end_name" :rules="end_name_R"></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;<font face="微軟正黑體" size="4" color="#CCA700">收件人連絡電話</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;<font face="微軟正黑體" size="4" color="#CCA700">手機：</font>
                <v-col>
                  <v-text-field outlined dense maxlength="10" background-color="#fff" height="5" style="height: 30px;  width: 200px;" v-model="end_phone" :rules="end_phone_R" placeholder="例:0912345678"></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;<font face="微軟正黑體" size="4" color="#CCA700">市話：</font>
                <v-col>
                  <v-text-field outlined dense maxlength="16" background-color="#fff" height="5" style="height: 30px;  width: 200px;" v-model="end_telphone" :rules="end_telphone_R" placeholder="例:02-12345678#分機"></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;<font face="微軟正黑體" size="4" color="#CCA700">收件人通訊地址</font>
              </v-row>
              <v-row class="mb-3" no-gutters>&ensp;
                <SelectZipcode v-model="end_cityIdx" :options="end_cities" />&emsp;
                <SelectZipcode v-model="end_areaIdx" :options="end_areas" />
              </v-row>
              <v-row class="mb-3" no-gutters>&ensp;
                <v-col>
                  <v-text-field outlined dense maxlength="24" background-color="#fff" height="5" style="height: 30px;  width: 360px;" v-model="end_address" :rules="end_address_R"></v-text-field>
                </v-col>
              </v-row>
            </b>
          </v-card>
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='05'">
            <v-card color="#5A5AAD" class=" pt-3 pb-3">
              <br />
            </v-card>
            <v-card color="#E6E6F2" class=" pt-3 pb-6">
              <b>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">溫層：</font>
                  &ensp;<input type="radio" id="runoob" value="01" v-model="goods_type" style="height: 30px;  width: 30px;"><label for="runoob">
                  </label>
                  <font face="微軟正黑體" size="4" color="#5A5AAD">常溫</font>
                  <!--&emsp;<input type="radio" id="runoob" value="02" v-model="goods_type" style="height: 30px;  width: 30px;"><label for="runoob">
                </label>
                <font face="微軟正黑體" size="4" color="#5A5AAD">冷凍</font>
                &emsp;<input type="radio" id="runoob" value="03" v-model="goods_type" style="height: 30px;  width: 30px;"><label for="runoob">
                </label>
                <font face="微軟正黑體" size="4" color="#5A5AAD">冷藏</font>-->
                </v-row>
                <div v-if="this.goods_type!=='01'">
                  &ensp;<font face="微軟正黑體" size="4" color="#FF5252">
                    {{goods_type_MSG}}<br /><br />
                  </font>
                </div>
                <div v-if="(this.today_Starttype===true)&&(this.today_Endtype===true)">
                  <v-row class="mb-3" no-gutters>
                    &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">當日宅配：&emsp;&emsp;&emsp;</font>
                    <select v-model="today_type">
                      <option value="F">否</option>
                      <option value="T">是</option>
                    </select>
                  </v-row>
                </div>
                <div v-else>
                  <v-row class="mb-3" no-gutters>
                    &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">當日宅配：&emsp;&emsp;&emsp;</font>
                    <select v-model="today_type" disabled>
                      <option value="F">否</option>
                      <option value="T">是</option>
                    </select>
                  </v-row>
                </div>
                <div v-if="this.today_type==='T'">
                  <v-row class="mb-3" no-gutters>
                    <font face="微軟正黑體" size="4" color="#FF5252">
                      &ensp;僅限台北市、新北市、基隆市三地互寄，當日<br />
                      &ensp;上午11：30前交寄，皆可於當日15~20時送達<br />
                    </font>
                  </v-row>
                </div>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">寄件日：&emsp;&emsp;&emsp;&emsp;</font>
                  <v2-datepicker v-model="entry_date" lang="en" format="YYYY/MM/DD" value="new Date()" disabled></v2-datepicker>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">希望配達日：&emsp;&emsp;</font>
                  <v2-datepicker v-model="assign_date" lang="en" format="YYYY/MM/DD"></v2-datepicker>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">希望配達時段：&emsp;</font>
                  <select v-model="assign_no">
                    <option value="00">不指定</option>
                    <option value="01">13時前</option>
                    <option value="02">14-18時</option>
                  </select>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">內容物：&emsp;&emsp;&emsp;&emsp;</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="5" background-color="#fff" height="5" style="height: 30px;  width: 160px;" v-model="product" :rules="product_R" placeholder="須和紙本欄位相同"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">商品價值：&emsp;&emsp;&emsp;</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="6" background-color="#fff" height="5" style="height: 30px;  width: 160px;" v-model="product_value" :rules="product_value_R" placeholder="須和紙本欄位相同"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">備註(上限20字)：</font>
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <v-col>
                    <v-text-field outlined dense maxlength="20" background-color="#fff" height="5" style="height: 30px;  width: 360px;" v-model="reg_memo" :rules="reg_memo_R"></v-text-field>
                  </v-col>
                </v-row>
              </b>
            </v-card>
          </div>
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='15'">
            <v-card color="#5B5B5B" class=" pt-3 pb-3">
              <br />
            </v-card>
            <v-card color="#F0F0F0" class=" pt-3 pb-6">
              <b>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">溫層：</font>
                  <!--&emsp;<input type="radio" id="runoob" value="01" v-model="goods_type" style="height: 30px;  width: 30px;"><label for="runoob">
                </label>
                <font face="微軟正黑體" size="4" color="#5B5B5B">常溫</font>-->
                  &emsp;<input type="radio" id="runoob" value="02" v-model="goods_type" style="height: 30px;  width: 30px;"><label for="runoob">
                  </label>
                  <font face="微軟正黑體" size="4" color="#5B5B5B">冷凍</font>
                  &emsp;<input type="radio" id="runoob" value="03" v-model="goods_type" style="height: 30px;  width: 30px;"><label for="runoob">
                  </label>
                  <font face="微軟正黑體" size="4" color="#5B5B5B">冷藏</font>
                </v-row>
                <div v-if="this.goods_type!==''">
                  &ensp;<font face="微軟正黑體" size="4" color="#FF5252">{{goods_type_MSG}}<br /></font>
                  &ensp;<font face="微軟正黑體" size="4" color="#FF5252">{{goods_type_MSG1}}<br /></font><br />
                </div>
                <div v-if="(this.today_Starttype===true)&&(this.today_Endtype===true)">
                  <v-row class="mb-3" no-gutters>
                    &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">當日宅配：&emsp;&emsp;&emsp;</font>
                    <select v-model="today_type">
                      <option value="F">否</option>
                      <option value="T">是</option>
                    </select>
                  </v-row>
                </div>
                <div v-else>
                  <v-row class="mb-3" no-gutters>
                    &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">當日宅配：&emsp;&emsp;&emsp;</font>
                    <select v-model="today_type" disabled>
                      <option value="F">否</option>
                      <option value="T">是</option>
                    </select>
                  </v-row>
                </div>
                <div v-if="this.today_type==='T'">
                  <v-row class="mb-3" no-gutters>
                    <font face="微軟正黑體" size="4" color="#FF5252">
                      &ensp;僅限台北市、新北市、基隆市三地互寄，當日<br />
                      &ensp;上午11：30前交寄，皆可於當日15~20時送達<br />
                    </font>
                  </v-row>
                </div>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">寄件日：&emsp;&emsp;&emsp;&emsp;</font>
                  <v2-datepicker v-model="entry_date" lang="en" format="YYYY/MM/DD" value="new Date()" disabled></v2-datepicker>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">希望配達日：&emsp;&emsp;</font>
                  <v2-datepicker v-model="assign_date" lang="en" format="YYYY/MM/DD"></v2-datepicker>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">希望配達時段：&emsp;</font>
                  <select v-model="assign_no">
                    <option value="00">不指定</option>
                    <option value="01">13時前</option>
                    <option value="02">14-18時</option>
                  </select>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">內容物：&emsp;&emsp;&emsp;&emsp;</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="5" background-color="#fff" height="5" style="height: 30px;  width: 160px;" v-model="product" :rules="product_R" placeholder="須和紙本欄位相同"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">商品價值：&emsp;&emsp;&emsp;</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="6" background-color="#fff" height="5" style="height: 30px;  width: 160px;" v-model="product_value" :rules="product_value_R" placeholder="須和紙本欄位相同"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">備註(上限20字)：</font>
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <v-col>
                    <v-text-field outlined dense maxlength="20" background-color="#fff" height="5" style="height: 30px;  width: 360px;" v-model="reg_memo" :rules="reg_memo_R"></v-text-field>
                  </v-col>
                </v-row>
              </b>
            </v-card>
          </div>
          </br>
          <!--<v-btn color="#F44336" x-large width="150" @click="dialog_ToteNotice = true">
          <font color="#FFF7FB">託運注意事項</font>
        </v-btn>-->
          <font face="微軟正黑體" size="3" color="#FF5252">提醒您：</font><br />
          <font face="微軟正黑體" size="4" color="#FF5252">1. 商品理賠上限為10,000元。</font><br />
          <div style="text-align:right">
            <div v-if="$cookie.get('dsmid_token').substr(1,2)==='05'">
              <!--<v-btn color="#5A5AAD" x-large @click="dialog_ToteNotice = true">-->
              <v-btn color="#5A5AAD" x-large @click="btnChkData()">
                <!--<font color="#FFF7FB">確定填寫資料</font>-->
                <font color="#FFF7FB">下一步</font>
              </v-btn>
            </div>
            <div v-if="$cookie.get('dsmid_token').substr(1,2)==='15'">
              <!--<v-btn color="#5B5B5B" x-large @click="dialog_ToteNotice = true">-->
              <v-btn color="#5B5B5B" x-large @click="btnChkData()">
                <!--<font color="#FFF7FB">確定填寫資料</font>-->
                <font color="#FFF7FB">下一步</font>
              </v-btn>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='05'">
            <v-card color="#5A5AAD" class=" pt-3 pb-3">
              <center>
                <b>
                  <font face="微軟正黑體" size="5" color="#E6E6F2">資料確認</font>
                </b>
              </center>
            </v-card>
            <v-card color="#E6E6F2" class=" pt-3 pb-3">
              <v-row class="mb-3" no-gutters>
                <b>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">寄件人</font>
                </b>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">名稱：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ start_name }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">電話：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ start_phone }}/{{ start_telphone }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">通訊地址：</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#555555"> {{start_zip}}&ensp;{{ this.start_cities[start_cityIdx].name }}{{ this.start_areas[start_areaIdx].name }}{{ start_address }}
                </font>
              </v-row>
              <br />
              <v-row class="mb-3" no-gutters>
                <b>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">收件人</font>
                </b>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">名稱：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ end_name }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">電話：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ end_phone }}/{{ end_telphone }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">通訊地址：</font><br />
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#555555"> {{end_zip}}&ensp;{{ this.end_cities[end_cityIdx].name }}{{ this.end_areas[end_areaIdx].name }}{{ end_address }}
                </font>
              </v-row>
              <br />
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">寄件日期：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ dateFormat(entry_date) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">希望配達日期：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ dateFormat(assign_date) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">希望配達時段：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ assign_no_name(assign_no) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">溫層：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ goods_type_name(goods_type) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">內容物：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ product }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">商品價值：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ product_value }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">備註：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ reg_memo }}</font>
              </v-row>
              <center>
                <v-btn color="#5A5AAD" x-large @click="btnBAKData()">
                  <font color="#E6E6F2" face="微軟正黑體" size="4">返回修改</font>
                </v-btn>&ensp;
                <!--<v-btn color="#5A5AAD" x-large @click="btnChkData()">-->
                <v-btn color="#5A5AAD" x-large @click="dialog_password=true">
                  <font color="#E6E6F2" face="微軟正黑體" size="4">確定送出</font>
                </v-btn>
              </center>
            </v-card>
          </div>
          <div v-else-if="$cookie.get('dsmid_token').substr(1,2)==='15'">
            <v-card color="#5B5B5B" class=" pt-3 pb-3">
              <center>
                <b>
                  <font face="微軟正黑體" size="5" color="#F0F0F0">資料確認</font>
                </b>
              </center>
            </v-card>
            <v-card color="#F0F0F0" class=" pt-3 pb-3">
              <v-row class="mb-3" no-gutters>
                <b>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">寄件人</font>
                </b>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">名稱：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ start_name }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">電話：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ start_phone }}/{{ start_telphone }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">通訊地址：</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#555555"> {{start_zip}}&ensp;{{ this.start_cities[start_cityIdx].name }}{{ this.start_areas[start_areaIdx].name }}{{ start_address }}
                </font>
              </v-row>
              <br />
              <v-row class="mb-3" no-gutters>
                <b>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">收件人</font>
                </b>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">名稱：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ end_name }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">電話：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ end_phone }}/{{ end_telphone }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">通訊地址：</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#555555"> {{end_zip}}&ensp;{{ this.end_cities[end_cityIdx].name }}{{ this.end_areas[end_areaIdx].name }}{{ end_address }}
                </font>
              </v-row>
              <br />
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">寄件日期：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ dateFormat(entry_date) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">希望配達日期：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ dateFormat(assign_date) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">希望配達時段：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ assign_no_name(assign_no) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">溫層：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ goods_type_name(goods_type) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">內容物：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ product }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">商品價值：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ product_value }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">備註：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ reg_memo }}</font>
              </v-row>

              <center>
                <v-btn color="#5B5B5B" x-large @click="btnBAKData()">
                  <font color="#F0F0F0" face="微軟正黑體" size="4">返回修改</font>
                </v-btn>&emsp;
                <!--<v-btn color="#5B5B5B" x-large @click="btnChkData()">-->
                <v-btn color="#5B5B5B" x-large @click="dialog_password=true">
                  <font color="#F0F0F0" face="微軟正黑體" size="4">確定送出</font>
                </v-btn>
              </center>
            </v-card>
          </div>
        </div>

        <v-row justify="center">
          <!--Dialog_託運條款-->
          <v-dialog v-model="dialog_Tote" persistent max-width="600">
            <v-card>
              <v-card-title class="text-h5 primary">
                <font color="#ECF5FF">託 運 條 款</font>
              </v-card-title>
              <v-card-text>
                </br>
                目 錄</br>
                &emsp;第 一 章 總則 （第一條～第二條）</br>
                &emsp;第 二 章 運送的收受 （第三條～第十條）</br>
                &emsp;第 三 章 貨件的送達 （第十一條～第十五條）</br>
                &emsp;第 四 章 指示 （第十六條～第十七條）</br>
                &emsp;第 五 章 責任 （第十八條～第二十二條）</br>
                &emsp;第 六 章 個資條款 （第二十三條）</br>
                </br>
                第 一 章 總 則</br>
                (適用範圍)</br>
                第 一 條 本條款適用於本公司所提供的貨件運送服務。</br>
                第 二 條 本運送條款所未規定之事項，依本公司公告之託運注意事項辦理，並以法令為準則。</br>
                </br>
                第 二 章 運 送 的 收 受</br>
                第 三 條 (取件日期、時間)</br>
                本公司各營業所於各代收點提出本公司所規定之取件時間為本公司取件時日。</br>
                前項所定之取件時日有變更時，由各營業所事先向各代收點公告說明。</br>
                第 四 條 (宅配單)</br>
                本公司於收受貨件運送時，須以一件貨件一張宅配單為之。</br>
                宅配單應記載以下事項，第一款至第五款由寄件人詳實填寫並簽名，第六款至第十一 款由本公司提示標明：</br>
                一、寄件人姓名或名稱，住址及電話號碼。</br>
                二、收件人姓名或名稱，收件人住址及電話號碼。</br>
                三、物品名稱、內容、貨物價值 (內容物欄位應具體敘明特定品項) 。</br>
                四、運送時特別注意事項（如：易碎物、3C、精密儀器等物品的特殊性質必要的事項記載）。</br>
                五、希望送達日（限定為距寄件日 7 日內）。</br>
                六、寄件日期。</br>
                七、物品大小的區分。</br>
                八、運費及其他費用的總金額。</br>
                九、賠償責任限度額。</br>
                十、本公司名稱及查詢電話號碼。</br>
                十一、其他有關運送之相關事項。</br>
                前項第五款寄件人特別指定日期，以本公司可接受的配送日期為準。</br>
                任何因寄件人所載貨品、宅配單未詳實填寫完全或宅配單填寫虛偽不實(包含但不限於內容物或價值)所致本公
                司之損害及責任(包含但不限於寄件人託運之貨品致本公司遭行政機關裁處之處分、罰鍰)，寄件人應負完全賠償責任。</br>
                第 五 條 (貨物內容的確認)</br>
                本公司對於宅配單上所記載之物品名稱或特別注意事項有疑問時，可經由寄件人同意，與寄件人同時檢查貨件內容。</br>
                本公司依前項規定做貨件檢查，如貨件與記載無出入，且因檢查過程貨件受損，將予以賠償。</br>
                依第一項之規定檢查貨件內容，若與所記載之內容不符時，檢查貨件時所花費之費用將由寄件人承擔。</br>
                第 六 條 寄件人必須依貨品之性質、重量、大小予以適當的包裝。</br>
                本公司對於包裝不完整之貨物，可要求寄件人重新包裝，若寄件人不予包裝，本公司得拒絕運送。</br>
                第 七 條 本公司對下列運送貨件不予以運送：</br>
                一、要求運送時，卻不符合運送條款者。</br>
                二、寄件人對於宅配單上之必要事項不予記載，或所記載之物品名稱或特別注意事項有疑問時不同意接受檢查者。</br>
                三、貨件之包裝不適合運送者。</br>
                四、於運送時，寄件人要求特別之負擔者。</br>
                五、貨件為下列之物品者：包含但不限於舉例之物品項目</br>
                1.火藥類(如：鞭炮、煙火、仙女棒)、易爆易燃類(如：汽油、柴油、煤油、酒精、油漆溶劑)、有毒有害物質、腐蝕性、毒品、管制藥品等危險或違禁品。</br>
                2.影響其他物品清潔之物品。</br>
                3.本公司公告之物品。</br>
                A.冰淇淋、冰棒及蛋糕(未裝飾的起士蛋糕除外)、母奶、水餃、餛飩、湯包等包內餡之麵類製品等需以特殊品溫儲存或容易變質之物品。</br>
                B.榴槤、鹹魚、臭豆腐等會散發特殊氣味，無以密封包裝之物品。</br>
                C.血液、尿液等檢體恐污染其他貨件之物品。</br>
                D.自寄件日當日起算，在三日以內即容易變質、腐壞、損毀及功能喪失等貨品（即保存期限三日(含)內會腐敗之貨品，不予賠償。）包括但不限於母奶、奶酪、雞蛋、豆腐、布丁…等。</br>
                E.現金、票據、股票等有價證券或貴金屬、珠寶、首飾、古董、藝術品等貴重物。</br>
                F.身分證、健保卡、行照、駕照、學生證、員工證、信用卡、金融卡、 SIM卡、護照、准考證、機票、車船票、票券、申請書、標單等類此之物品。</br>
                G.活體：包含但不限於貓、狗、鳥類、爬蟲、魚類、植物( 如盆栽、種苗、切花、水耕等)等活體。</br>
                H.印章、原稿、原圖、遺骨、牌位、佛像、包含資料之硬碟或隨身碟等具有唯一性無法復原或再製之物品。</br>
                I.信函、明信片或其他具有通信性質、包含個人資料文件之郵件。</br>
                J.未按規定填寫宅配單者、宅配單未詳實填寫完全或填寫虛偽不實或收件人地址不明確之貨品，包含但不限於郵政信箱…等。</br>
                K.其他非法、具危險性質或有違公共秩序，善良風俗的物品。</br>
                L.單件商品價值超過壹萬元之物品。</br>
                M.常溫貨品規格(長+寬+高)超過 150 公分或重量超過 20 公斤之物品；低溫貨品規格(長+寬+高)超過 120 公分或單邊超出 75 公分或重量超過 20 公斤之物品。</br>
                六、未進行預冷之低溫貨品。(低溫宅配物品交寄前應先將物品預冷，冷藏物品(+4°C~+8°C) 須事先預冷 6 小時以上，冷凍物品(-18°C)須事先預冷 12 小時以上，並於外箱張貼冷藏、冷凍標示。)</br>
                七、因天災或不可避免之事由(包含運送延遲所導致)者。</br>
                八、交寄離島包裹務必確認不含液體類包裹與航空違禁品(3C、爆裂物、化學藥劑等)，否則託運人需擔負罰鍰、完全賠償責任與相關法律責任。</br>
                第 八 條 (外裝表示)</br>
                本公司於收受貨件時，應將第四條應記載之項目及其他必要注意事項，黏貼於貨件外裝上。</br>
                第 九 條 (運費等的收受)</br>
                本公司於收取貨件時，同時向寄件人收取運費及其他相關費用。</br>
                運費計算標準由營業所提供予各代收點。</br>
                本公司之運費不予打折，且已收取貨物之運費不予退還。</br>
                第 十 條 (連絡運輸或利用運輸)</br>
                本公司在不損害寄件人的利益下，可將所收受之貨件將委由其他運送機關或貨運公司代為運送。</br>
                </br>
                第 三 章 貨 件 的 送 達</br>
                第 十一 條 (配送貨物日)</br>
                除寄件至離島地區外，本公司以下列記載為配送貨物日：</br>
                一、宅配單上所記載之希望送達日。</br>
                二、宅配單上未記載貨件預定送達日，以本公司取件時日起三日。</br>
                第 十二 條 (對於收件人以外的收件者)</br>
                寄件人同意下列情形視同收件人收受：</br>
                一、配送處為住家者，以送達處之管理人、同居者或類此之人。</br>
                二、配送處為前款以外者，以管理人、受雇人（或同事）、或類此之人。</br>
                第 十三 條 (收件人不在之處置)</br>
                收件人不在或無前條所列之代收人時，本公司將以電話、簡訊或送達通知單通知收件人，此貨物由營業所代為保管。</br>
                上開收件人代收時，應於宅配單上填寫代收人之姓名。</br>
                第 十四 條 (無法配送之處理方式)</br>
                無法與收件人取得連繫或收件人拒收貨件時，或因可歸責於收件人理由致貨件無法送達時，本公司於相當期間內與
                寄件人取得連繫後，得另行約定貨件處理方案。另行約定處理方案，如無法約定，本公司得按貨件性質逕行處置。</br>
                前項貨件處理方案所需之費用由寄件人負擔。</br>
                第 十五 條 (無法配送貨件之處置)</br>
                無法依據前兩條配送時，本公司不負遲延責任及保管責任。</br>
                </br>
                第 四 章 指 示</br>
                第 十六 條 (指示)</br>
                寄件人對於本公司之貨件之運送時，可以中止配送、退回、或轉送或其他的指示。</br>
                前項所定之寄件人權利，為貨件送達收件人處為止。</br>
                寄件人為第一項之新指示，應先行簽署變更指示單，並支付所有處理費用。</br>
                第 十七 條 (危險物品的處理)</br>
                本公司運送時若得知貨件為第七條之物品時，為防止該貨件或其他貨件受損，得停止對此貨品之運送。</br>
                前項處理貨件所需之費用由寄件人負擔。</br>
                </br>
                第 五 章 責 任</br>
                第 十八 條 (責任與舉證)</br>
                本公司將貨件交付收件人後，本公司之責任消滅。</br>
                第 十九 條 (免責)</br>
                下列事由，造成貨件之遺失、損傷或遲送的損害，本公司將不負予賠償之責任：</br>
                一、貨件的缺陷、自然的損耗。</br>
                二、因貨件的性質所引起之起火、爆炸、悶熱、發霉、腐敗、變色、生鏽等其他類似之事由。</br>
                三、同行罷工或同行怠業，社會的暴動（亂）及其他事變或是遇強盜。</br>
                四、不歸責於本公司所引起之火災。</br>
                五、無法預知或不可抗力或其他機關所導致之交通障礙。</br>
                六、地震、海嘯、高（漲）潮、淹水、暴風雨、土石流、山崩等其他之天災。</br>
                七、因法令或公權力，致使運送中止，拆封、沒收、查封押交予第三者。</br>
                八、因第十三條及第十四條所致遲延者。</br>
                九、依第七條不予運送之責任。</br>
                第 二十 條 (收受限制貨物等)</br>
                寄送人於宅配單上未明載貨件為易碎物、3C、精密儀器等物品的特殊物質易變質或腐敗等之需特別注意之貨件者而發生貨件受損時，本公司不負賠償責任。</br>
                第二十一條 (受損賠償之金額)</br>
                本公司對於遺失之貨件，根據貨件之價格（以下指寄件處之貨件價格）及責任限制額新臺幣壹萬元整（以下稱為限制額度）範圍內賠償之。</br>
                本公司對於運送時導致貨件毀損所致之損失，以貨件之成本價值為基準，依貨件受損之程度在限制額度範圍內賠償之。</br>
                本公司遲延送達者，於運費之範圍內賠償之。</br>
                本公司因遺失或毀損而導致遲到之損失時，所產生之損賠總額計算，於限制額度之範圍內賠償之。</br>
                除上述規定外，本公司對任何間接損失或衍生性損害不負賠償責任。</br>
                第二十二條 (寄件人之賠償責任)</br>
                寄件人未告知本公司關於貨件之性質問題致本公司遭受損失，應負損害賠償責任。</br>
                </br>
                第 六 章 個 資 條 款</br>
                第二十三條 (蒐集、處理、利用個資之告知)</br>
                本公司蒐集個人資料為提供宅配服務之業務需要，並僅供本公司及委外廠商處理及利用，本公司蒐集、處理或利用個人資料將遵循個人資料保護法之規定。</br>
                </br>
                <div style="text-align:right">
                  2020/05/13 修改</br>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" x-large width="100" @click="dialog_Tote = false;dialog_Security = true">
                  <font size="4">同 意</font>
                </v-btn>
                <v-btn color="warning" x-large width="100" :to="{ name: 'EndPagefail2c' }">
                  <font size="4">不同意</font>
                </v-btn>
              </v-card-actions></br>
            </v-card>
          </v-dialog>
          <!--Dialog_資訊安全政策說明-->
          <v-dialog v-model="dialog_Security" persistent max-width="600">
            <v-card>
              <v-card-title class="text-h5 primary">
                <font color="#ECF5FF">資 訊 安 全 政 策 說 明</font>
              </v-card-title>
              <v-card-text>
                </br>
                台灣宅配通股份有限公司基於營運作業及公司政策之需要，提供物流宅配流程委外的服務。本公司以資訊科技為基礎，及專業的經驗與理念，為
                企業量身訂做物流宅配流程委外服務模組，協助企業提升競爭力，創造優勢。因此，本公司資訊系統之資訊安全控管措施，在於保護客戶及交易
                資料等資訊之機密性、完整性及可用性。同時強化資訊安全管理，確保資料、系統、設備及網路安全，以營造可靠的交易資訊環境、提昇資訊防
                護技術、落實執行資訊安全管理作業；期以精益求精、不斷革新之精神，以提升優質服務而努力。基於此目標，本公司資訊安全政策聲明為：</br></br>
                <center><b>
                    <font face="微軟正黑體" color="#FF5252" size="5">資 訊 安 全 ，人 人 有 責</font>
                  </b></center></br>
                <font face="微軟正黑體" size="3">宅台灣宅配通隱私權政策</font></br>
                大嘴鳥宅配通（即台灣宅配通股份有公司；以下簡稱本公司）因業務相關而且有必要性，並為提供客戶更完善服務，而為個人資料之蒐集、處理
                或利用，本公司絕對遵守「個人資料保護法」及相關法令之規定，尊重當事人之權益、避免人格權受侵害，並且依誠實及信用方法為之，不逾越
                特定目的之必要範圍，並與蒐集之目的具有正當合理之關聯。本公司就保護個人資料及隱私權之相關具體作法並說明如後。</br></br>
                詳細內容</br>
                壹、蒐集客戶資料之使用目的：</br>
                一、貨件收受與配送。</br>
                二、倉儲業務服務。</br>
                三、電子商務相關之服務。</br>
                四、產品銷售服務。</br>
                五、客戶資料管理及相關服務。</br>
                六、資訊與資料庫管理。</br>
                七、人事業務。</br>
                八、行銷及經營企劃相關分析。</br>
                九、其他本公司依法得經營之業務。</br></br>
                貳、客戶資料之蒐集範圍：</br>
                依照客戶與本公司之間的具體關係，本公司將直接或間接經由業務合作對象取得以下資料：</br>
                一、寄件人: 取得寄件人的姓名、地址、電話等託運所需資料。</br>
                二、收件人: 從寄件人處取得收件人的姓名、電話、地址、代收貨款金額等資料。</br>
                三、契約客戶: 取得契約客戶的姓名、地址、電話、國民身分證影本、電子信箱及存摺封面影本等及前項收件人之個人資料。</br>
                四、公司會員: 取得會員的姓名、出生年月日、身分證統一編號、電話、地址及電子信箱等資料。</br>
                五、應徵者及外包人員: 將從人力銀行或人力派遣公司取得應徵者及外包人員的履歷等相關資訊，該資訊可能包括：</br>
                1.基本資料：包括姓名、出生年月日、身份證統一編號、電話、地址及電子信箱及親屬等資料。</br>
                2.教育、技術或其他專業：包括學歷、資格或技術、專長等資料。</br>
                3.工作經歷：包括現行工作情形、以前工作經驗等資料。</br>
                六、除上述情形外，本公司如基於蒐集目的必要範圍內蒐集其他資料時，會另行告知蒐集內容。</br>
                客戶有提供個人資料與否及範圍的選擇性。若客戶選擇拒絕提供該項個人資料或是提供不完整或是錯誤之資料時，將有可能無法提供客戶完善的服務。</br>
                參、客戶資料之處理及利用範圍：</br>
                一、除經客戶事先同意外，本公司僅會將自客戶取得的個人資料，使用在與客戶有關而提供的服務上。除了將貨件託運至國外的情形外，本公司只會在台灣地區內處理或利用客戶的個人資料。</br>
                二、為提供完善的服務，本公司若有必要再委託予第三方(包含國內外業務合作對象或是其他運送人)之情形時，而本公司需將客戶個人資料
                揭露予第三方者，該個人資料收受方，必需是有能力提供適當保護措施者。本公司亦將會對該個人資料收受方不定時進行查核及監督。</br>
                肆、客戶資料之儲存方式及期間：</br>
                一、本公司訂有嚴格的個人資料安全維護規定，本公司取得的個人資料將受嚴密、安全的保存。同時，任何人因業務相關，有必要進行資料
                之取得與使用時，亦必需依安全維護規定為之。而與業務無關之任何人，均不得亦無法取得資料。</br>
                二、除法令另有規定外，應徵資料應於面試後如確認不予錄用立即刪除、託運資料書面保存一年，掃描檔保留 400天，失效合約書除有特別
                原因外保存一年。保存期間屆滿後將依法停止處理、利用或刪除。</br>
                伍、客戶資料查詢、變更及刪除等之方式：</br>
                一、客戶留存於本公司自己之個人資料，得依法向本公司以書面或電子文件請求行使查詢、補充、更正、閱覽、製給複製本；請求停止蒐集
                、處理或利用；請求刪除等權利。惟前述權利，若因不符合法律規定或第二項之申請程序者，則不在此限。</br>
                二、若客戶就註冊資料向本公司請求答覆、查詢、閱覽或製給複製本時，本公司得酌收必要成本費用。而前述之申請，應填具申請文件，本
                公司得向客戶請求提出可資確認之身分證明文件，若委託他人代為申請者，並應出具委任書，且提供本人及代理人之身分證明文件。</br>
                三、若客戶個人資料有變更，客戶可自行於本公司網頁進行更正。</br>
                四、如果客戶不願意將個人資料提供予本公司或本公司之業務合作對象繼續使用，可致電本公司客服中心，本公司將停止使用客戶的個人資料。</br>
                陸、資料安全及保護方法：</br>
                一、本公司保有客戶個人資料檔案者，皆採行適當之安全措施，防止客戶個人資料被竊取、竄改、毀損、滅失或洩漏。</br>
                二、對於客戶的個人資料，本公司以Secure Sockets Layer（SSL）機制進行加密傳輸，並加裝防火牆防止不法入侵，避免客戶個人</br>
                柒：個人資料的揭露：</br>
                除事先經過客戶的同意及下列情形外，本公司絕不會將客戶個人資料揭露予任何人。</br>
                一、執行業務所需</br>
                基於本公司為完成業務服務及達成前述蒐集及使用目的之需求，本公司會將部份工作委由外部服務提供者辦理，例如國內外之其他運送業者、業務合作對象、會計師、律師和其他專業顧問、客戶服務等。</br>
                二、履行法定義務</br>
                在以下必要的情況下，本公司有可能會將客戶的個人資料揭露予第三人：</br>
                1. 司法單位或其他主管機關經合法正式的程序要求時。</br>
                2. 其他依法辦理之事項。</br>
                捌、諮詢事項：</br>
                若客戶對於本公司隱私權政策或是對於個人資料蒐集、利用或處理有任何疑問。或者欲向本公司要求查詢或請求閱覽、製給複製本、補充或
                更正、停止蒐集、處理或利用、刪除等事宜。</br></br>
                若有上述需求，請於上班時間與本公司客服中心聯絡。</br>
                一、服務時間：週一至週日08：30 - 19：00</br>
                二、服務電話：(02)6618-1818</br>
                三、聯絡電子信箱：service@e-can.com.tw</br></br>
                隱私權政策之生效及修正：</br>
                本隱私權政策自中華民國107年07月23日生效，但是為因應法令及社會環境之變遷，並為絕對保護您的個人資料安全及隱私權，本公司將定期檢視
                並可能再修正隱私權政策。若有任何修正，本公司將會刊登於網站上公告週知。</br>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" x-large width="100" @click="dialog_Security = false">
                  <font size="4">同 意</font>
                </v-btn>
                <v-btn color="warning" x-large width="100" :to="{ name: 'EndPagefail2c' }">
                  <font size="4">不同意</font>
                </v-btn>
              </v-card-actions></br>
            </v-card>
          </v-dialog>
          <!--Dialog_託運注意事項-->
          <!--<v-dialog v-model="dialog_ToteNotice" persistent max-width="600">
            <v-card>
              <v-card-title class="text-h5 warning">
                <font color="#FFF3EE">託 運 注 意 事 項</font>
              </v-card-title>
              <v-card-text>
                </br>
                1.請勿交寄商品價值超過壹萬元之物品。</br>
                <font color="#FF5252">
                  2.不可交寄物品：現金、有價證券、票券、護照、身分證、標單、珠寶等其他貴重物品或檢體、活體、危險物品、違禁品、具有通信性質之文件、包裝不良品
                  及自寄件日當日起算三日內即容易變質、腐壞、損毀及功能喪失等物品。特殊品溫儲存的物品如：母乳、水餃、餛飩、湯包等包內餡的麵類製品、冰品及蛋
                  高（未裝飾的起司蛋糕除外）等物品。其餘不可交寄物品之種類詳見託運條款及本公司官網。</br>
                  3.交寄離島包裹務必確認不含液體類包裹與航空違禁品（3C、爆裂物、化學藥劑等），否則託運人需擔負罰緩、完全賠償責任與相關法律責任。寄件至離島地
                  區，恕無法指定希望配達日及時段。
                </font></br>
                4.本公司對於託運物之喪失、毀損應負之責任，以貨件之成本價值並參酌本單據所填貨物價值為判斷賠償依據，不包括運送物本體以外之其他附帶利益或所失
                利益，常溫貨物請於收到貨件三日內（含）提出，逾期得不受理相關賠償等請求；低溫貨物配送完成後，本公司之負責消滅。</br>
                5.宅配單如有填寫虛偽不實（包含但不限於內容物或價值），運送人不負任何運送損害配償責任，且所致本公司之損害及責任（包含但不限於寄託人託運之貨
                品致本公司遭行政機關裁處之處分、罰緩），寄件人應負完全賠償責任。</br>
                6.本單據未經代收點或本公司人員簽章者無效。</br>
                7.個資法及各項託運條款，請詳閱託運條款及隱私權政策。</br>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" x-large width="100" @click="btnAgreeType()">
                  <font size="4">同 意</font>
                </v-btn>
                <v-btn color="warning" x-large width="100" :to="{ name: 'EndPagefail2c' }">
                  <font size="4">不同意</font>
                </v-btn>
              </v-card-actions></br>
            </v-card>
          </v-dialog>-->
          <v-dialog v-model="dialog_password" persistent max-width="600">
            <v-card>
              <v-card-title class="text-h5 warning">
                <font color="#FFF3EE">修 改 / 查 詢 提 示</font>
              </v-card-title>
              <v-card-text>
                </br>
                <font face="微軟正黑體" size="5" color="warning">
                  <div v-if="this.start_phone !== ''">
                    密碼為&ensp;{{this.start_phone}}
                  </div>
                  <div v-else>
                    密碼為&ensp;{{this.start_telphone}}
                  </div>
                </font>
                </br>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning" x-large width="100" @click="btnchkPassword()">
                  <font size="4">確 定</font>
                </v-btn>
              </v-card-actions></br>
            </v-card>
          </v-dialog>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
  <v-overlay :value="overlay">
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
</div>
</template>

<script>
import SelectZipcode from "../../components/SelectZipcode";
import cities from "../../components/zipcode.json";

export default {
  components: {
    SelectZipcode,
  },
  data() {
    return {
      dialog_Tote: true,
      dialog_Security: false,
      dialog_ToteNotice: false,
      dialog_password: false,
      overlay: false,
      agree_type: false,
      btnAgreeType_temp: false,
      insupd_type: false,
      utype: 'ins',
      start_name: '', //寄件人姓名
      start_name_R: [
        (v) => {
          if (RegExp(/[\\/'"=&<>%]/).test(v.substr(-1, 1))) {
            this.start_name = this.start_name.substr(0, this.start_name.length - 1);
            alert('請勿使用不合規則字元');
            return false
          } else {
            if (RegExp(/[\\/'"=&<>%]/).test(v)) {
              this.start_name = '';
              alert('資料中有不合規則字元');
              return false
            }
            return true
          }
        },
      ],
      start_phone: '', //寄件人手機
      start_phone_R: [
        (v) => !!v || " ",
        (v) => {
          if (!RegExp(/^[0-9]*$/).test(v)) {
            this.start_phone = ''
          }
          return true
        },
      ],
      start_telphone: '', //寄件人市話 RegExp(/^[^0-9-\-#]*$/).test(v)
      start_telphone_R: [
        (v) => !!v || " ",
        (v) => {
          if (!RegExp(/^[0-9 \-#]*$/).test(v)) {
            this.start_telphone = ''
          }
          return true
        },
      ],
      start_cityIdx: 0, //撈取寄件人縣市用
      start_areaIdx: 0, //撈取寄件人鄉政用
      start_address: '', //寄件人地址
      start_address_R: [
        (v) => {
          if (RegExp(/[\\/'"=&<>%]/).test(v.substr(-1, 1))) {
            this.start_address = this.start_address.substr(0, this.start_address.length - 1);
            alert('請勿使用不合規則字元');
            return false
          } else {
            if (RegExp(/[\\/'"=&<>%]/).test(v)) {
              this.start_address = '';
              alert('資料中有不合規則字元');
              return false
            }
            return true
          }
        },
      ],
      end_name: '', //收件人姓名
      end_name_R: [
        (v) => {
          if (RegExp(/[\\/'"=&<>%]/).test(v.substr(-1, 1))) {
            this.end_name = this.end_name.substr(0, this.end_name.length - 1);
            alert('請勿使用不合規則字元');
            return false
          } else {
            if (RegExp(/[\\/'"=&<>%]/).test(v)) {
              this.end_name = '';
              alert('資料中有不合規則字元');
              return false
            }
            return true
          }
        },
      ],
      end_phone: '', //收件人手機
      end_phone_R: [
        (v) => !!v || " ",
        (v) => {
          if (!RegExp(/^[0-9 #]*$/).test(v)) {
            this.end_phone = ''
          }
          return true
        },
      ],
      end_telphone: '', //收件人市話 RegExp(/^[^0-9-\-#]*$/).test(v)
      end_telphone_R: [
        (v) => !!v || "",
        (v) => {
          if (!RegExp(/^[0-9 \-#]*$/).test(v)) {
            this.end_telphone = ''
          }
          return true
        },
      ],
      end_cityIdx: 0, //撈取收件人縣市用
      end_areaIdx: 0, //撈取收件人鄉政用
      end_address: '', //收件人地址
      end_address_R: [
        (v) => {
          if (RegExp(/[\\/'"=&<>%]/).test(v.substr(-1, 1))) {
            this.end_address = this.end_address.substr(0, this.end_address.length - 1);
            alert('請勿使用不合規則字元');
            return false
          } else {
            if (RegExp(/[\\/'"=&]/).test(v)) {
              this.end_address = '';
              alert('資料中有不合規則字元');
              return false
            }
            return true
          }
        },
      ],
      goods_type: '', //溫層
      goods_type_MSG: '',
      goods_type_MSG1: '',
      today_type: 'F',
      today_Starttype: false,
      today_Endtype: false,
      entry_date: new Date(), //寄件日
      assign_date: new Date(new Date().getTime() + 24 * 60 * 60 * 1000), //希望配答日
      assign_no: '00', //希望配達時段
      product: '', //商品名
      product_R: [
        (v) => {
          if (RegExp(/[\\/'"=&<>%]/).test(v)) {
            this.product = '';
            alert('資料中有不合規則字元');
          }
          return true
        },
      ],
      product_value: '', //商品價值
      product_value_R: [
        (v) => !!v || " ",
        //(v) => v < 10000 || " ",
        (v) => {
          if (v > 10000) {
            alert('商品金額上限為10,000元');
            this.product_value = ''
          }
          return true
        },
        (v) => {
          if (!RegExp(/^[0-9]*$/).test(v)) {
            this.product_value = ''
          }
          return true
        },
      ],
      reg_memo: '', //備註
      reg_memo_R: [
        (v) => {
          if (RegExp(/[\\/'"=&<>]/).test(v.substr(-1, 1))) {
            this.reg_memo = this.reg_memo.substr(0, this.reg_memo.length - 1);
            alert('請勿使用不合規則字元');
            return false
          } else {
            if (RegExp(/[\\/'"=&]/).test(v)) {
              this.reg_memo = '';
              alert('資料中有不合規則字元');
              return false
            }
            return true
          }
        },
      ],
    };
  },
  mounted: function() {
    this.checkPage();
    this.goods_type_check();
  },
  computed: {
    start_cities() {
      return cities;
    },
    start_areas() {
      return cities[this.start_cityIdx].areas;
    },
    start_zip() {
      return this.start_areas[this.start_areaIdx].zip;
    },
    end_cities() {
      return cities;
    },
    end_areas() {
      return cities[this.end_cityIdx].areas;
    },
    end_zip() {
      return this.end_areas[this.end_areaIdx].zip;
    },
  },
  watch: {
    start_cityIdx() {
      this.start_areaIdx = 0;
      if ((this.start_cityIdx === 1) || (this.start_cityIdx === 2) || (this.start_cityIdx === 3)) {
        this.today_Starttype = true;
      } else {
        this.today_Starttype = false;
        this.today_type = 'F';
      }
    },
    end_cityIdx() {
      this.end_areaIdx = 0;
      if ((this.end_cityIdx === 1) || (this.end_cityIdx === 2) || (this.end_cityIdx === 3)) {
        this.today_Endtype = true;
      } else {
        this.today_Endtype = false;
        this.today_type = 'F';
      }
    },
    goods_type() {
      if (this.goods_type === '02') {
        this.goods_type_MSG = "交寄冷凍貨件前請務必預冷12小時以上，";
        this.goods_type_MSG1 = "成凍結狀態";
      } else if (this.goods_type === '03') {
        this.goods_type_MSG = "交寄冷藏貨件前請務必預冷6小時以上";
        this.goods_type_MSG1 = "";
      } else {
        this.goods_type_MSG = "";
        this.goods_type_MSG1 = "";
      }
    },
    dialog_password(val) {
      if (!val) return
      setTimeout(() => (
        this.btnchkPassword()
      ), 30000)
    },
  },
  methods: {
    checkPage: function() {
      if (this.$cookie.get('page_token') != 'S') {
        this.$router.push({
          name: "ErrorPage"
        });
      } else {
        let page_token = 'E';
        this.$cookie.set('page_token', page_token, "0");
      }
    },
    goods_type_check() {
      if (this.$cookie.get('dsmid_token').substr(1, 2) === '05') {
        this.goods_type = '01';
      } else {
        this.goods_type = '';
      }
    },
    dateFormat(time) {
      let date = new Date(time);
      let year = date.getFullYear();
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

      return year.toString() + month.toString() + day.toString();
    },
    assign_no_name(assign_no) {
      if (assign_no === '00') {
        return '不指定';
      } else if (assign_no === '01') {
        return '13時前';
      } else if (assign_no === '02') {
        return '14-18時';
      } else {
        return '';
      }
    },
    goods_type_name(goods_type) {
      if (goods_type === '01') {
        return '常溫';
      } else if (goods_type === '02') {
        return '冷凍';
      } else if (goods_type === '03') {
        return '冷藏';
      } else {
        return '';
      }
    },
    btnBAKData() {
      this.insupd_type = true;
      this.agree_type = false;
    },
    btnAgreeType() {
      if ((this.start_name !== '') &&
        ((this.start_phone !== '') || (this.start_telphone !== '')) &&
        (this.start_zip !== '') &&
        (this.start_address !== '') &&
        (this.end_name !== '') &&
        ((this.end_phone !== '') || (this.end_telphone !== '')) &&
        (this.end_zip !== '') &&
        (this.end_address !== '') &&
        (this.goods_type !== '') &&
        (this.product_value !== '')
      ) {
        if (this.product_value > 10000) {
          alert('提醒您!!商品理賠上限為10,000元!!');
        }
        //this.dialog_ToteNotice = false;
        //this.agree_type = true;
        this.btnAgreeType_temp = true;
      } else {
        //this.dialog_ToteNotice = false;
        if ((this.start_name === '') ||
          ((this.start_phone === '') && (this.start_telphone === '')) ||
          (this.start_zip === '') ||
          (this.start_address === '')
        ) {
          this.btnAgreeType_temp = false;
          alert('寄件人資料不完整');
        }
        if ((this.end_name === '') ||
          ((this.end_phone === '') && (this.end_telphone === '')) ||
          (this.end_zip === '') ||
          (this.end_address === '')
        ) {
          this.btnAgreeType_temp = false;
          alert('收件人資料不完整');
        }
        if (this.goods_type === '') {
          this.btnAgreeType_temp = false;
          alert('請選擇溫層');
        }
        if (this.product_value === '') {
          this.btnAgreeType_temp = false;
          alert('請輸入商品價值');
        }
      }
    },
    btnChkData() {
      this.overlay = true;
      //let posturl = 'https://queryapi.e-can.com.tw:9097/EDIQR2CAPI/EDIQR2C_UpdData';
      let posturl = 'https://queryapi2.e-can.com.tw:9091/EDIQR2CAPI/EDIQR2C_UpdData';
      let axiosConfig = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      if (this.start_cityIdx === 0) {
        this.start_cityname = '';
      } else {
        this.start_cityname = this.start_cities[this.start_cityIdx].name;
      }
      if ((this.start_areaIdx === 0) && (this.start_cityIdx === 0)) {
        this.start_areaname = '';
      } else {
        this.start_areaname = this.start_areas[this.start_areaIdx].name;
      }
      if (this.start_areaname === '請選擇區域別') {
        this.start_areaname = '';
      }
      if (this.agency_receipt === '') {
        this.agency_receipt = '0';
      }
      if (this.insupd_type === true) {
        this.utype = "upd";
      } else {
        this.utype = "ins";
      }
      let postdata = JSON.stringify({
        "utype": this.utype,
        "main_id": this.$cookie.get('dsmid_token').substr(0, 12),
        "seq_id": this.$cookie.get('dsmid_token').substr(12, 3),
        "spec_id": "01",
        "total_obj": "1",
        "customer_delivery_date": "",
        "agencystore_no": "",
        "delivery_sheet_date": "",
        "company_no": "",
        "inquiry_char": "",
        "start_name": this.start_name,
        "start_phone": this.start_phone,
        "start_telphone": this.start_telphone,
        "start_zpcode": this.start_zip,
        "start_cityno": this.start_cityIdx,
        "start_cityname": this.start_cityname,
        "start_areano": this.start_areaIdx,
        "start_areaname": this.start_areaname,
        "start_addr": this.start_address,
        "end_name": this.end_name,
        "end_phone": this.end_phone,
        "end_telphone": this.end_telphone,
        "end_zpcode": this.end_zip,
        "end_cityno": this.end_cityIdx,
        "end_cityname": this.end_cities[this.end_cityIdx].name,
        "end_areano": this.end_areaIdx,
        "end_areaname": this.end_areas[this.end_areaIdx].name,
        "end_addr": this.end_address,
        "assign_date": this.dateFormat(this.assign_date),
        "assign_no": this.assign_no,
        "original_carriage": "",
        "agency_receipt": "0",
        "goods_type": this.goods_type,
        "input_type": "6",
        "src_type": "1",
        "pay_type": "1",
        "delivery_record": "0",
        "operator_id": "999999",
        "memo": this.reg_memo,
        "start_email": "",
        "crg_memo": "",
        "print_code": "0",
        "seq_no": "1",
        "cust_seq_id": "01",
        "transfer_code": "0",
        "outspec_code": "0",
        "pickup_price": "0",
        "receive_target": "2",
        "payment_target": "1",
        "product": this.product,
        "product_value": this.product_value,
        "effective_code": "1"
      });

      /*let options = {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        data: postdata,
        url: posturl,
      };*/
      //this.$axios.post(posturl, postdata, axiosConfig).then((response) => console.log('success'))
      //  .catch((error) => console.log(error));
      this.btnAgreeType();
      if (this.btnAgreeType_temp === true){
        this.$axios.post(posturl, postdata, axiosConfig).then((response) => {
            if (response.data.pcode === '0') {
              this.overlay = false;
              alert('上傳失敗：' + response.data.desc);
              this.$router.push({
                name: "ErrorPage"
              });
            } else {
              console.log('上傳成功');
              this.overlay = false;
              if (this.agree_type === true) {
                this.dialog_password = true;
                console.log('[確定資料]上傳成功');
              } else {
                //this.btnAgreeType();
                console.log('[KEY資料]上傳成功');
                this.insupd_type = true;
                this.agree_type = true;
              }
              //this.$router.push({
              //  name: "EndPage2c"
              //});
            }
          })
          .catch((error) => console.log(error));
      } else {
        this.overlay = false;
        this.agree_type = false;
      };

    },
    btnchkPassword() {
      this.dialog_password = false;
      this.$router.push({
        name: "EndPage2c"
      });
    },
  },
}
</script>
